import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const listRegional = async (payload) => {
    const { data } = await apiInstance.post(ENDPOINTS.REGIONAL_LIST, payload);
    return data
}
